import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import type { RootState } from '../store'

import { actionTypes } from './types'
import { changeStartDateOfPlanService } from './services'

export const name = 'planning'

export type PlanningState = {
  progress: number
  isCheckingCache: boolean
  changeStartDateOfPlan: typeof changeStartDateOfPlanService.state
}

//
// Initial state
//

const initialState: PlanningState = {
  progress: 0,
  isCheckingCache: false,
  changeStartDateOfPlan: changeStartDateOfPlanService.state,
}

//
// Slice (Actions & Reducers)
//

//
// Slice (Actions & Reducers)
//
const slice = createSlice({
  name,
  initialState,
  reducers: {
    load: () => undefined,
    check: () => undefined,
    setIsCheckingCache: (state, action: actionTypes.setIsCheckingCache) => {
      state.isCheckingCache = action.payload
    },
    download: () => undefined,
    remove: () => undefined,
    setProgress: (state, action: actionTypes.setProgress) => {
      state.progress = action.payload
    },
    changeStartDateOfPlanRequest: changeStartDateOfPlanService.reducers.request,
    changeStartDateOfPlanSuccess: changeStartDateOfPlanService.reducers.success,
    changeStartDateOfPlanError: changeStartDateOfPlanService.reducers.error,
    changeStartDateOfPlanReset: changeStartDateOfPlanService.reducers.reset,
  },
  extraReducers: {
    [HYDRATE]: (state) => {
      // do not overwrite planning state
      return state
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[name]
const progress = (state: RootState) => root(state).progress
const isCheckingCache = (state: RootState) => root(state).isCheckingCache

export const selectors = {
  progress,
  isCheckingCache,
}
